import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'

interface ResetsOnTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const ResetsOnTooltip: React.FC<ResetsOnTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        {translate(
          'Set by your card issuer. Your credit limit resets on this date each cycle.',
        )}
      </p>
    </Tooltip>
  )
}

export default ResetsOnTooltip
